export const INSTANT_QUOTE_SEGMENT = "instantQuote";
export const RANGE_QUOTE_SEGMENT = "rangeQuote";
